<template>
    <v-container fluid>
        <div v-if="isSubmitting" class="text-xs-center">
            <v-progress-linear :indeterminate="isSubmitting" color="secondary">
            </v-progress-linear>
        </div>
        <h1>Submit Quote/Order to Sales</h1>
        <v-form ref="form" :disabled="quotes.length === 0">
            <v-container id="input-usage" grid-list-xl fluid>
                <v-layout wrap row>
                    <v-flex xs12>
                        <v-text-field
                                v-model="name"
                                v-validate="'required|max:255'"
                                :error-messages="errors.collect('name')"
                                data-vv-name="name"
                                name="name"
                                label="Quote/Order Name"
                                placeholder="Enter quote/order name"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea
                                v-model="message"
                                name="message"
                                label="Message to Sale"
                                placeholder="Enter message to sales"
                        ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                        <v-checkbox
                            v-model="isThirdPartyDrop"
                            name="isThirdPartyDrop"
                            label="Deliver to Third Party?"
                            color="primary"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea
                                :disabled="!isThirdPartyDrop"
                                v-model="thirdPartyAddress"
                                name="thirdPartyAddress"
                                :error-messages="errors.collect('thirdPartyAddress')"
                                data-vv-name="thirdPartyAddress"
                                label="Third Party Contact Name/Delivery Address"
                                placeholder="Enter third party contact name and delivery address"
                                v-validate="ruleIsThirdParty"
                        ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                                :disabled="!isThirdPartyDrop"
                                v-model="thirdPartyTelephone"
                                :error-messages="errors.collect('thirdPartyTelephone')"
                                data-vv-name="thirdPartyTelephone"
                                name="thirdPartyTelephone"
                                label="Third Party Telephone"
                                placeholder="Enter third party telephone"
                                v-validate="ruleIsThirdParty"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-radio-group row v-model="submissionType" v-validate="'required'" :error-messages="errors.collect('submissionType')" data-vv-name="submissionType">
                            <v-radio label="This is a Quote" value="quote" color="primary"></v-radio>
                            <v-radio label="This is an Order" value="order" color="primary"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-btn color="success" :disabled="errors.any()" @click="onSubmit">Submit</v-btn>
        </v-form>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'QuotesSubmit',
  data: function () {
    return {
      name: null,
      message: null,
      submissionType: null,
      isThirdPartyDrop: false,
      thirdPartyAddress: null,
      thirdPartyTelephone: null,
      isSubmitting: false
    }
  },
  created () {
    if (this.quotes.length === 0) {
      this.$router.push({ name: 'quotes' })
    }
    this.reset()
  },
  computed: {
    ...mapGetters('quote', { quotes: 'quotes' }),
    ruleIsThirdParty () {
      return this.isThirdPartyDrop ? 'required' : ''
    }
  },
  methods: {
    ...mapActions(
      'quote', {
        clearQuotes: 'clear'
      }
    ),
    reset () {
      this.name = process.env.VUE_APP_QUOTE_NAME
      this.message = process.env.VUE_APP_QUOTE_MESSAGE
      this.submissionType = null
      this.isThirdPartyDrop = process.env.VUE_APP_QUOTE_IS_THIRD_PARTY_DROP === 'true'
      this.thirdPartyAddress = process.env.VUE_APP_QUOTE_THIRD_PARTY_ADDRESS
      this.thirdPartyTelephone = process.env.VUE_APP_QUOTE_THIRD_PARTY_TELEPHONE
      this.$validator.reset()
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doQuote()
        } else {
          this.$snotify.error(this.$validator.errors.all())
        }
      })
    },
    doQuote () {
      this.$snotify.success('Submitting quote/order to backend')
      this.isSubmitting = true
      this.axios.post('quote', {
        params: {
          distributor_id: this.$auth.user().id,
          name: this.name,
          message: this.message,
          is_quote: this.submissionType === 'quote',
          is_third_party_drop: this.isThirdPartyDrop,
          third_party_drop_address: this.thirdPartyAddress,
          third_party_drop_telephone: this.thirdPartyTelephone,
          items: this.quotes
        },
        paramsSerializer: (params) => this.$qs.stringify(params, { arrayFormat: 'repeat' })
      }).then((response) => {
        this.$snotify.success(response.data.data.success)
        this.reset()
        this.clearQuotes(this)
        this.$router.push({ name: 'home' })
      }).catch((error) => {
        this.$snotify.error(error.response.data.data.error)
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  }

}
</script>

<style scoped>

</style>
